import axios from 'axios';
import {getI18n} from "react-i18next";
import {RawAxiosRequestHeaders} from "axios/index";
import {getAuth} from 'firebase/auth';
import {initializeApp} from "firebase/app";
import {FIREBASE_API} from "../config";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true
});

const firebaseApp = initializeApp(FIREBASE_API);

const AUTH = getAuth(firebaseApp);

api.interceptors.request.use(
    async (request) => {
        const headers: any = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Accept': 'application/json; charset=UTF-8',
            'Accept-Language': 'pt_BR'
        };
        if (isAuthenticatedURL(request.method, request.url)) {
            const currentToken = await AUTH.currentUser?.getIdToken();
            if (currentToken) {
                headers['Authorization'] = `Bearer ${currentToken}`;
            }
        }
        request.headers = headers;

        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function isAuthenticatedURL(
    method: string | undefined,
    url: string | undefined
): boolean {
    if (method === 'get' && url?.startsWith('auth/users/username/available/')) {
        return false;
    }
    return true;
}

export default api;
